import React from "react";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import CustomText from "../CustomText";
import Color from "../../../utils/Color";
import "fontsource-muli";
import AuthManager from "../../../utils/AuthManager";

const CustomButton = ({ classes, ...props }) => {
  const {
    design,
    title,
    variant = "outlined",
    fullWidth = true,
    textstyle,
    icon,
    iconleft,
    onClick = () => {},
    children,
    disabledBtn = false,
  } = props;

  return (
    <Button
      className={`${classes.rootV2} ${design}`}
      variant={variant}
      fullWidth={fullWidth}
      onClick={() => onClick && !disabledBtn && onClick()}
      {...props}
    >
      {iconleft ? iconleft : false}
      {title ? (
        <CustomText className={`${classes.textStyle} ${textstyle}`}>
          {title}
        </CustomText>
      ) : (
        false
      )}
      {icon ? icon : false}
      {children}
    </Button>
  );
};

const styles = () => ({
  root: {
    backgroundColor: "#00B4AF",
    borderRadius: 8,
    color: Color.white,
    borderColor: "#00B4AF",
    border: "solid 1px",
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      color: Color.black,
      backgroundColor: "#00B4AF",
    },
  },
  rootV2: {
    backgroundColor: "#FEC31A",
    borderRadius: 8,
    color: Color.black,
    borderColor: "#FEC31A",
    border: "solid 1px",
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      color: Color.white,
      backgroundColor: "#FEC31A",
    },
  },
  textStyle: {
    textTransform: "capitalize",
    fontWeight: "bold",
    fontFamily: "Muli",
    fontSize: 16,
  },
  buttonStyle: {},
});

export default withStyles(styles)(CustomButton);
